// extracted by mini-css-extract-plugin
export default {"brand":"Brands_brand__Letqt","base":"Brands_base__YDbRd","header":"Brands_header__Q+May","controls":"Brands_controls__N-O-R","buttons":"Brands_buttons__tLdmn"};